'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosRoseOutline = function IoIosRoseOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.7 12c-0.3 0-0.7 0.2-1 0.3-2.9 0.8-5.6 1.8-8.1 3-1.3 0.6-1.9 1-3.4 1.9l-0.6 0.3c-2.4 1.4-3.9 2.6-4.9 4-1.2 1.6-1.7 3.5-1.7 6 0 1.3 0.2 2.3 0.7 3.4 0.5 1.1 1.1 2.1 2 2.9 1.8 1.6 4.3 2.5 7.3 2.5s5.5-0.9 7.3-2.5c0.9-0.8 1.5-1.8 2-2.9 0.5-1.1 0.7-2.1 0.7-3.4 0-1.6-0.4-3.1-0.9-4.7-0.8-3.1-1.8-6.5 0.6-10.8z m2.8-2c-6 7.5-1.2 11.8-1.2 17.5s-4.4 10-11.3 10-11.2-4.3-11.2-10 2.7-8.5 7.2-11.1c2-1.1 2.6-1.5 4.1-2.2 2.3-1.1 5.1-2.2 8.2-3.1 1.3-0.4 2.7-0.8 4.2-1.1z m-22-0.4c1.1 2.2 1.4 4.5 1.5 6.5 0.7-0.6 1.5-1 2.3-1.6 0.5-0.3 1.1-0.7 1.6-1 0.4-0.2 0.8-0.5 1.3-0.7-0.4-0.3-0.9-0.5-1.3-0.8-1.8-1.1-3.8-1.8-5.4-2.4z m-3-2.1s5.2 1.2 9 3.4c1.2 0.6 2.2 1.4 2.9 2.2-1 0.5-1.9 1-2.8 1.5-0.6 0.3-1.1 0.6-1.6 0.9-2 1.3-3.4 2.5-4.5 3.3 0.4-3.2 0.2-7.6-3-11.3z m19.5-1.2c-0.7 0.1-1.6 0.2-2.8 0.6-1.9 0.6-3.7 1.5-5 2.8 0.6 0.5 1.2 0.9 1.7 1.4 2.2-0.9 5-2 7.4-2.7-0.4-0.7-1-1.5-1.3-2.1z m0.5-1.3s2 2.5 2.5 4.3c-2.6 0.6-6.6 2-9.5 3.3l-0.2-0.3c-0.7-0.8-1.7-1.7-3-2.5 4-4.6 10.2-4.8 10.2-4.8z m-13.4-0.8c-0.4 0.8-0.7 1.6-1.1 2.2 1 0.3 1.8 0.8 2.9 1.3 0.3-0.4 0.7-0.7 1.1-1.1-1.1-1.1-2.2-1.9-2.9-2.4z m-0.3-1.7s2.7 1.3 5 4.4c-1 0.7-1.8 1.5-2.6 2.4-2.1-1-3.2-1.6-4.8-2.1 0.4-1.2 1.2-3 2.4-4.7z' })
        )
    );
};

exports.default = IoIosRoseOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-rose-outline.js
// module id = 2509
// module chunks = 0